module.exports = __webpack_public_path__ + "static/media/sedal.e27a7e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/sedal.png
// module id = 969
// module chunks = 0